import { render, staticRenderFns } from "./ImagenesEventos.vue?vue&type=template&id=ac4fb7ec&scoped=true"
import script from "./ImagenesEventos.vue?vue&type=script&lang=js"
export * from "./ImagenesEventos.vue?vue&type=script&lang=js"
import style0 from "./ImagenesEventos.vue?vue&type=style&index=0&id=ac4fb7ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4fb7ec",
  null
  
)

export default component.exports